<div class="staff-dashboard core-screen">
  <section class="staff-dashboard__toolbar staff-dashboard__toolbar--refresh-only">
    <button
      type="button"
      class="staff-dashboard__refresh-button"
      (click)="refreshDashboard()"
    >
      {{ 'STAFF.DASHBOARD.TOOLBAR.REFRESH' | translate }}
    </button>
  </section>

  @if (dashboardAccessDenied()) {
  <p class="staff-dashboard__state staff-dashboard__state--error">
    {{ 'STAFF.DASHBOARD.STATE.ACCESS_DENIED' | translate }}
  </p>
  } @else if (dashboardError()) {
  <div class="staff-dashboard__state-wrap">
    <p class="staff-dashboard__state staff-dashboard__state--error">
      {{ 'STAFF.DASHBOARD.STATE.LOAD_ERROR' | translate }}
    </p>
    <button type="button" class="staff-dashboard__retry" (click)="refreshDashboard()">
      {{ 'STAFF.DASHBOARD.STATE.RETRY' | translate }}
    </button>
  </div>
  } @else if (showAdminLayout()) {
  <section class="staff-dashboard__section" aria-labelledby="staff-dashboard-health-title">
    <div class="staff-dashboard__section-head">
      <h2 id="staff-dashboard-health-title" class="staff-dashboard__section-title">
        {{ 'STAFF.DASHBOARD.HEALTH.TITLE' | translate }}
      </h2>
      <span class="staff-dashboard__snapshot-badge">
        {{ 'STAFF.DASHBOARD.METRIC.SNAPSHOT' | translate }}
      </span>
    </div>

    <div class="staff-dashboard__health-groups">
      <article
        class="staff-dashboard__finance-group staff-dashboard__finance-group--debtors"
        aria-labelledby="staff-dashboard-health-debtors-title"
      >
        <header class="staff-dashboard__finance-group-head">
          <div class="staff-dashboard__finance-group-intro">
            <h3
              id="staff-dashboard-health-debtors-title"
              class="staff-dashboard__finance-group-title"
            >
              {{ 'STAFF.DASHBOARD.HEALTH.DEBTORS_GROUP_TITLE' | translate }}
            </h3>
            <p class="staff-dashboard__finance-group-desc">
              {{ 'STAFF.DASHBOARD.HEALTH.DEBTORS_GROUP_DESC' | translate }}
            </p>
          </div>
          @if (debtorsCountValue() > 0) {
          <button
            type="button"
            class="staff-dashboard__finance-action staff-dashboard__finance-action--debtors"
            (click)="openDebtors()"
          >
            {{ 'STAFF.DASHBOARD.FINANCE.OPEN_DEBTORS' | translate }}
          </button>
          }
        </header>

        <div class="staff-dashboard__finance-grid staff-dashboard__finance-grid--debtors">
          <div class="staff-dashboard__finance-hero">
            <lib-staff-kpi-card
              [labelKey]="'STAFF.DASHBOARD.HEALTH.DEBTORS_COUNT'"
              [hintKey]="'STAFF.DASHBOARD.HEALTH.DEBTORS_COUNT_HINT'"
              [value]="debtorsCountValue()"
              [loading]="dashboardLoading()"
              tone="debtor"
              size="prominent"
              align="start"
              [labelFirst]="true"
              (cardClick)="openDebtors()"
            />
          </div>
          <lib-staff-kpi-card
            [labelKey]="'STAFF.DASHBOARD.HEALTH.DEBTORS_TOTAL'"
            [hintKey]="'STAFF.DASHBOARD.HEALTH.DEBTORS_TOTAL_HINT'"
            [value]="debtorsTotalLabel()"
            [loading]="dashboardLoading()"
            tone="debtor"
            align="start"
            [labelFirst]="true"
            (cardClick)="openDebtors()"
          />
          <lib-staff-kpi-card
            [labelKey]="'STAFF.DASHBOARD.HEALTH.DEBTORS_SHARE'"
            [hintKey]="'STAFF.DASHBOARD.HEALTH.DEBTORS_SHARE_HINT'"
            [hintParams]="debtorsShareHintParams()"
            [value]="debtorsShareLabel()"
            [loading]="dashboardLoading()"
            tone="debtor"
            align="start"
            [labelFirst]="true"
            (cardClick)="openDebtors()"
          />
        </div>
      </article>

      <article
        class="staff-dashboard__finance-group staff-dashboard__finance-group--wallet"
        aria-labelledby="staff-dashboard-health-wallet-title"
      >
        <header class="staff-dashboard__finance-group-head">
          <div class="staff-dashboard__finance-group-intro">
            <h3
              id="staff-dashboard-health-wallet-title"
              class="staff-dashboard__finance-group-title"
            >
              {{ 'STAFF.DASHBOARD.HEALTH.WALLET_GROUP_TITLE' | translate }}
            </h3>
            <p class="staff-dashboard__finance-group-desc">
              {{ 'STAFF.DASHBOARD.HEALTH.WALLET_GROUP_DESC' | translate }}
            </p>
          </div>
        </header>

        <div class="staff-dashboard__finance-grid staff-dashboard__finance-grid--wallet">
          <div class="staff-dashboard__finance-hero">
            <lib-staff-kpi-card
              [labelKey]="'STAFF.DASHBOARD.HEALTH.CLIENTS_BALANCE'"
              [hintKey]="'STAFF.DASHBOARD.HEALTH.CLIENTS_BALANCE_HINT'"
              [value]="clientsBalanceLabel()"
              [loading]="dashboardLoading()"
              tone="wallet"
              size="prominent"
              align="start"
              [labelFirst]="true"
              [clickable]="false"
            />
          </div>
          <lib-staff-kpi-card
            [labelKey]="'STAFF.DASHBOARD.HEALTH.CLIENTS_AVG_BALANCE'"
            [hintKey]="'STAFF.DASHBOARD.HEALTH.CLIENTS_AVG_BALANCE_HINT'"
            [value]="clientsAvgBalanceLabel()"
            [loading]="dashboardLoading()"
            tone="wallet"
            align="start"
            [labelFirst]="true"
            [clickable]="false"
          />
          <lib-staff-kpi-card
            [labelKey]="'STAFF.DASHBOARD.HEALTH.WALLET_ACTIVE_AVG_BALANCE'"
            [hintKey]="'STAFF.DASHBOARD.HEALTH.WALLET_ACTIVE_AVG_BALANCE_HINT'"
            [hintParams]="walletActiveAvgBalanceHintParams()"
            [value]="walletActiveAvgBalanceLabel()"
            [loading]="dashboardLoading()"
            tone="wallet"
            align="start"
            [labelFirst]="true"
            [clickable]="false"
          />
          <lib-staff-kpi-card
            [labelKey]="'STAFF.DASHBOARD.HEALTH.STORAGE_AVG_BALANCE'"
            [hintKey]="'STAFF.DASHBOARD.HEALTH.STORAGE_AVG_BALANCE_HINT'"
            [hintParams]="storageAvgBalanceHintParams()"
            [value]="storageAvgBalanceLabel()"
            [loading]="dashboardLoading()"
            tone="wallet"
            align="start"
            [labelFirst]="true"
            [clickable]="false"
          />
          <lib-staff-kpi-card
            [labelKey]="'STAFF.DASHBOARD.HEALTH.NON_STORAGE_BALANCE'"
            [hintKey]="'STAFF.DASHBOARD.HEALTH.NON_STORAGE_BALANCE_HINT'"
            [hintParams]="nonStorageBalanceHintParams()"
            [value]="nonStorageBalanceLabel()"
            [loading]="dashboardLoading()"
            tone="wallet"
            align="start"
            [labelFirst]="true"
            [clickable]="false"
          />
        </div>
      </article>

      <article
        class="staff-dashboard__finance-group staff-dashboard__finance-group--storage"
        aria-labelledby="staff-dashboard-health-storage-title"
      >
        <header class="staff-dashboard__finance-group-head">
          <div class="staff-dashboard__finance-group-intro">
            <h3
              id="staff-dashboard-health-storage-title"
              class="staff-dashboard__finance-group-title"
            >
              {{ 'STAFF.DASHBOARD.HEALTH.STORAGE_GROUP_TITLE' | translate }}
            </h3>
            <p class="staff-dashboard__finance-group-desc">
              {{ 'STAFF.DASHBOARD.HEALTH.STORAGE_GROUP_DESC' | translate }}
            </p>
          </div>
        </header>

        <div class="staff-dashboard__finance-grid staff-dashboard__finance-grid--storage">
          <lib-staff-kpi-card
            [labelKey]="'STAFF.DASHBOARD.HEALTH.STORAGE_CHARGE_TODAY'"
            [hintKey]="'STAFF.DASHBOARD.HEALTH.STORAGE_CHARGE_TODAY_HINT'"
            [hintParams]="storageChargeTodayHintParams()"
            [value]="storageDailyChargeLabel()"
            [loading]="dashboardLoading()"
            tone="wallet"
            align="start"
            [labelFirst]="true"
            [clickable]="false"
          />
          <lib-staff-kpi-card
            [labelKey]="'STAFF.DASHBOARD.HEALTH.STORAGE_CHARGE_TOMORROW'"
            [hintKey]="'STAFF.DASHBOARD.HEALTH.STORAGE_CHARGE_TOMORROW_HINT'"
            [value]="estimatedTomorrowChargeLabel()"
            [loading]="dashboardLoading()"
            tone="wallet"
            align="start"
            [labelFirst]="true"
            [clickable]="false"
          />
          <lib-staff-kpi-card
            [labelKey]="'STAFF.DASHBOARD.HEALTH.ACTIVE_STORAGE_CLIENTS'"
            [hintKey]="'STAFF.DASHBOARD.HEALTH.ACTIVE_STORAGE_CLIENTS_HINT'"
            [value]="activeStorageClientsValue()"
            [loading]="dashboardLoading()"
            align="start"
            [labelFirst]="true"
            (cardClick)="openUsers()"
          />
          <lib-staff-kpi-card
            [labelKey]="'STAFF.DASHBOARD.HEALTH.ORDERS_ATTENTION'"
            [hintKey]="'STAFF.DASHBOARD.HEALTH.ORDERS_ATTENTION_HINT'"
            [value]="ordersAttentionValue()"
            [loading]="dashboardLoading()"
            [highlight]="ordersAttentionValue() > 0"
            align="start"
            [labelFirst]="true"
            (cardClick)="openOrders()"
          />
        </div>
      </article>
    </div>

    @if (risks(); as risks) {
    @if (risks.debt_aging.length > 0) {
    <div class="staff-dashboard__debt-aging" aria-labelledby="staff-dashboard-debt-aging-title">
      <div class="staff-dashboard__subsection-head">
        <h3 id="staff-dashboard-debt-aging-title" class="staff-dashboard__subsection-title">
          {{ 'STAFF.DASHBOARD.HEALTH.DEBT_AGING_TITLE' | translate }}
        </h3>
        <p class="staff-dashboard__subsection-desc">
          {{ 'STAFF.DASHBOARD.HEALTH.DEBT_AGING_DESC' | translate }}
        </p>
      </div>
      <div class="staff-dashboard__debt-aging-grid">
        @for (bucket of risks.debt_aging; track bucket.label) {
        <button
          type="button"
          class="staff-dashboard__debt-aging-item"
          (click)="openDebtors()"
        >
          <span class="staff-dashboard__debt-aging-count">{{ bucket.count }}</span>
          <span class="staff-dashboard__debt-aging-total">
            {{ formatDebtAgingTotal(bucket.total_bynd) }}
          </span>
          <span class="staff-dashboard__debt-aging-label">
            {{ debtAgingLabel(bucket.label) }}
          </span>
        </button>
        }
      </div>
    </div>
    }

    @if (actionAlerts().length > 0) {
    <div class="staff-dashboard__risks" aria-labelledby="staff-dashboard-risks-title">
      <h3 id="staff-dashboard-risks-title" class="staff-dashboard__subsection-title">
        {{ 'STAFF.DASHBOARD.HEALTH.ACTIONS_TITLE' | translate }}
      </h3>
      <div class="staff-dashboard__risk-list">
        @for (alert of actionAlerts(); track alert.type) {
        <button
          type="button"
          class="staff-dashboard__risk-item"
          [class.staff-dashboard__risk-item--high]="alert.severity === 'high'"
          [class.staff-dashboard__risk-item--medium]="alert.severity === 'medium'"
          [disabled]="!alert.route"
          (click)="openRiskAlert(alert)"
        >
          <span class="staff-dashboard__risk-count">{{ alert.count }}</span>
          <span class="staff-dashboard__risk-label">{{ riskAlertLabel(alert.type) }}</span>
        </button>
        }
      </div>
    </div>
    }
    }
  </section>

  <section class="staff-dashboard__section" aria-labelledby="staff-dashboard-warehouse-title">
    <div class="staff-dashboard__section-head">
      <h2 id="staff-dashboard-warehouse-title" class="staff-dashboard__section-title">
        {{ 'STAFF.DASHBOARD.WAREHOUSE.TITLE' | translate }}
      </h2>
      <span class="staff-dashboard__snapshot-badge">
        {{ 'STAFF.DASHBOARD.METRIC.SNAPSHOT' | translate }}
      </span>
    </div>

    @if (summary(); as summary) {
    <div class="staff-dashboard__kpi-grid staff-dashboard__kpi-grid--warehouse">
      <lib-staff-kpi-card
        [labelKey]="'STAFF.DASHBOARD.WAREHOUSE.OCCUPIED'"
        [hintKey]="'STAFF.DASHBOARD.WAREHOUSE.OCCUPIED_HINT'"
        [value]="occupiedVolumeLabel()"
        [metricKind]="'snapshot'"
        [loading]="dashboardLoading()"
        [highlight]="true"
        align="start"
        (cardClick)="openWarehouses()"
      />
      <lib-staff-kpi-card
        [labelKey]="'STAFF.DASHBOARD.WAREHOUSE.FREE'"
        [hintKey]="'STAFF.DASHBOARD.WAREHOUSE.FREE_HINT'"
        [value]="freeVolumeLabel()"
        [metricKind]="'snapshot'"
        [loading]="dashboardLoading()"
        align="start"
        (cardClick)="openWarehouses()"
      />
      <lib-staff-kpi-card
        [labelKey]="'STAFF.DASHBOARD.WAREHOUSE.STORED_UNITS'"
        [hintKey]="'STAFF.DASHBOARD.WAREHOUSE.STORED_UNITS_HINT'"
        [value]="storedUnitsValue(summary)"
        [metricKind]="'snapshot'"
        [loading]="dashboardLoading()"
        align="start"
        [clickable]="false"
      />
      <lib-staff-kpi-card
        [labelKey]="'STAFF.DASHBOARD.WAREHOUSE.ACTIVE'"
        [hintKey]="'STAFF.DASHBOARD.WAREHOUSE.ACTIVE_HINT'"
        [value]="kpiValue(summary, 'warehouses_active')"
        [metricKind]="'snapshot'"
        [loading]="dashboardLoading()"
        align="start"
        (cardClick)="openWarehouses()"
      />
    </div>
    }

    @if (warehouses().length > 0) {
    <div class="staff-dashboard__warehouse-breakdown" aria-labelledby="staff-dashboard-warehouse-list-title">
      <h3 id="staff-dashboard-warehouse-list-title" class="staff-dashboard__subsection-title">
        {{ 'STAFF.DASHBOARD.WAREHOUSE.LIST_TITLE' | translate }}
      </h3>

      <div class="staff-dashboard__warehouse-cards">
        @for (warehouse of warehouses(); track warehouse.id) {
        <button
          type="button"
          class="staff-dashboard__warehouse-card"
          (click)="openWarehouse(warehouse)"
        >
          <div class="staff-dashboard__warehouse-card-head">
            <span class="staff-dashboard__warehouse-name">{{ warehouse.name }}</span>
            <span class="staff-dashboard__warehouse-volume">
              {{ warehouseVolumeLabel(warehouse) }}
            </span>
          </div>
          <div
            class="staff-dashboard__warehouse-bar"
            role="img"
            [attr.aria-label]="warehouseVolumeLabel(warehouse)"
          >
            <div
              class="staff-dashboard__warehouse-bar-fill"
              [style.width.%]="warehouseBarWidth(warehouse)"
            ></div>
          </div>
          <span class="staff-dashboard__warehouse-units">
            {{
              'STAFF.DASHBOARD.WAREHOUSE.ITEMS'
                | translate: { count: warehouse.stored_units }
            }}
          </span>
        </button>
        }
      </div>

      <div class="staff-dashboard__warehouse-table-wrap">
        <table class="staff-dashboard__warehouse-table">
          <thead>
            <tr>
              <th scope="col">
                {{ 'STAFF.DASHBOARD.WAREHOUSE.COL_NAME' | translate }}
              </th>
              <th scope="col">
                {{ 'STAFF.DASHBOARD.WAREHOUSE.COL_OCCUPANCY' | translate }}
              </th>
              <th scope="col">
                {{ 'STAFF.DASHBOARD.WAREHOUSE.COL_ITEMS' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            @for (warehouse of warehouses(); track warehouse.id) {
            <tr>
              <td>
                <button
                  type="button"
                  class="staff-dashboard__warehouse-link"
                  (click)="openWarehouse(warehouse)"
                >
                  {{ warehouse.name }}
                </button>
              </td>
              <td>
                <div class="staff-dashboard__warehouse-table-occupancy">
                  <span class="staff-dashboard__warehouse-volume">
                    {{ warehouseVolumeLabel(warehouse) }}
                  </span>
                  <div
                    class="staff-dashboard__warehouse-bar"
                    role="img"
                    [attr.aria-label]="warehouseVolumeLabel(warehouse)"
                  >
                    <div
                      class="staff-dashboard__warehouse-bar-fill"
                      [style.width.%]="warehouseBarWidth(warehouse)"
                    ></div>
                  </div>
                </div>
              </td>
              <td class="staff-dashboard__warehouse-table-items">
                {{
                  'STAFF.DASHBOARD.WAREHOUSE.ITEMS'
                    | translate: { count: warehouse.stored_units }
                }}
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    } @else if (!dashboardLoading()) {
    <p class="staff-dashboard__warehouse-empty">
      {{ 'STAFF.DASHBOARD.WAREHOUSE.EMPTY' | translate }}
    </p>
    }
  </section>

  <ng-container *ngTemplateOutlet="attentionSection" />
  } @else {
  <section class="staff-dashboard__kpi-grid">
    <lib-staff-kpi-card
      [labelKey]="'STAFF.DASHBOARD.KPI.ORDERS_ATTENTION'"
      [value]="ordersAttentionValue()"
      [loading]="dashboardLoading()"
      (cardClick)="openOrders()"
    />

    @if (summary(); as summary) {
    @if (visibility().showClientsKpi) {
    <lib-staff-kpi-card
      [labelKey]="'STAFF.DASHBOARD.KPI.CLIENTS'"
      [value]="kpiValue(summary, 'clients')"
      [loading]="dashboardLoading()"
      (cardClick)="openUsers()"
    />
    }

    @if (visibility().showEmployeesKpi) {
    <lib-staff-kpi-card
      [labelKey]="'STAFF.DASHBOARD.KPI.EMPLOYEES'"
      [value]="kpiValue(summary, 'employees')"
      [loading]="dashboardLoading()"
      (cardClick)="openEmployees()"
    />
    }

    @if (visibility().showWarehousesKpi) {
    <lib-staff-kpi-card
      [labelKey]="'STAFF.DASHBOARD.KPI.WAREHOUSES_ACTIVE'"
      [value]="kpiValue(summary, 'warehouses_active')"
      [loading]="dashboardLoading()"
      (cardClick)="openWarehouses()"
    />
    }

    @if (visibility().showStorageKpi) {
    <lib-staff-kpi-card
      [labelKey]="'STAFF.DASHBOARD.KPI.BOXES_STORED'"
      [value]="storedUnitsValue(summary)"
      [loading]="dashboardLoading()"
      [clickable]="false"
    />
    <lib-staff-kpi-card
      [labelKey]="'STAFF.DASHBOARD.KPI.VOLUME_M3'"
      [value]="volumeLabel()"
      [loading]="dashboardLoading()"
      [clickable]="false"
    />
    <lib-staff-kpi-card
      [labelKey]="'STAFF.DASHBOARD.KPI.OCCUPANCY_PERCENT'"
      [value]="occupancyLabel()"
      [highlight]="true"
      [loading]="dashboardLoading()"
      [clickable]="false"
    />
    }

    @if (visibility().showBoxTypesKpi) {
    <lib-staff-kpi-card
      [labelKey]="'STAFF.DASHBOARD.KPI.BOX_TYPES'"
      [value]="kpiValue(summary, 'box_types')"
      [loading]="dashboardLoading()"
      (cardClick)="openBoxTypes()"
    />
    }
    }
  </section>

  @if (visibility().showWalletKpi && summary()) {
  <section
    class="staff-dashboard__finance"
    aria-labelledby="staff-dashboard-finance-title-legacy"
  >
    <h2 id="staff-dashboard-finance-title-legacy" class="staff-dashboard__finance-title">
      {{ 'STAFF.DASHBOARD.FINANCE.TITLE' | translate }}
    </h2>

    <div class="staff-dashboard__finance-groups">
      <article
        class="staff-dashboard__finance-group staff-dashboard__finance-group--debtors"
        aria-labelledby="staff-dashboard-finance-debtors-title"
      >
        <header class="staff-dashboard__finance-group-head">
          <div class="staff-dashboard__finance-group-intro">
            <h3
              id="staff-dashboard-finance-debtors-title"
              class="staff-dashboard__finance-group-title"
            >
              {{ 'STAFF.DASHBOARD.FINANCE.DEBTORS_TITLE' | translate }}
            </h3>
            <p class="staff-dashboard__finance-group-desc">
              {{ 'STAFF.DASHBOARD.FINANCE.DEBTORS_DESC' | translate }}
            </p>
          </div>
          @if (debtorsCountValue() > 0) {
          <button
            type="button"
            class="staff-dashboard__finance-action staff-dashboard__finance-action--debtors"
            (click)="openDebtors()"
          >
            {{ 'STAFF.DASHBOARD.FINANCE.OPEN_DEBTORS' | translate }}
          </button>
          }
        </header>

        <div class="staff-dashboard__finance-grid staff-dashboard__finance-grid--debtors">
          <div class="staff-dashboard__finance-hero">
            <lib-staff-kpi-card
              [labelKey]="'STAFF.DASHBOARD.KPI.WALLET_DEBTORS_COUNT'"
              [value]="debtorsCountValue()"
              [loading]="dashboardLoading()"
              tone="debtor"
              size="prominent"
              align="start"
              (cardClick)="openDebtors()"
            />
          </div>
          <lib-staff-kpi-card
            [labelKey]="'STAFF.DASHBOARD.KPI.WALLET_DEBTORS_TOTAL'"
            [value]="debtorsTotalLabel()"
            [loading]="dashboardLoading()"
            tone="debtor"
            align="start"
            (cardClick)="openDebtors()"
          />
          <lib-staff-kpi-card
            [labelKey]="'STAFF.DASHBOARD.KPI.WALLET_DEBTORS_SHARE'"
            [value]="debtorsShareLabel()"
            [hintKey]="'STAFF.DASHBOARD.KPI.WALLET_DEBTORS_SHARE_HINT'"
            [hintParams]="debtorsShareHintParams()"
            [loading]="dashboardLoading()"
            tone="debtor"
            align="start"
            (cardClick)="openDebtors()"
          />
        </div>
      </article>

      <article
        class="staff-dashboard__finance-group staff-dashboard__finance-group--wallet"
        aria-labelledby="staff-dashboard-finance-wallet-title"
      >
        <header class="staff-dashboard__finance-group-head">
          <div class="staff-dashboard__finance-group-intro">
            <h3
              id="staff-dashboard-finance-wallet-title"
              class="staff-dashboard__finance-group-title"
            >
              {{ 'STAFF.DASHBOARD.FINANCE.WALLET_TITLE' | translate }}
            </h3>
            <p class="staff-dashboard__finance-group-desc">
              {{ 'STAFF.DASHBOARD.FINANCE.WALLET_DESC' | translate }}
            </p>
          </div>
        </header>

        <div class="staff-dashboard__finance-grid staff-dashboard__finance-grid--wallet">
          <div class="staff-dashboard__finance-hero">
            <lib-staff-kpi-card
              [labelKey]="'STAFF.DASHBOARD.KPI.WALLET_CLIENTS_BALANCE'"
              [value]="clientsBalanceLabel()"
              [loading]="dashboardLoading()"
              tone="wallet"
              size="prominent"
              align="start"
              [clickable]="false"
            />
          </div>
          <lib-staff-kpi-card
            [labelKey]="'STAFF.DASHBOARD.KPI.WALLET_AVERAGE_BALANCE'"
            [value]="clientsAvgBalanceLabel()"
            [loading]="dashboardLoading()"
            tone="wallet"
            align="start"
            [clickable]="false"
          />
          <lib-staff-kpi-card
            [labelKey]="'STAFF.DASHBOARD.KPI.WALLET_STORAGE_DAILY_CHARGE'"
            [value]="storageDailyChargeLabel()"
            [hintKey]="'STAFF.DASHBOARD.KPI.WALLET_STORAGE_CHARGE_DATE'"
            [hintParams]="storageChargeDateHintParams()"
            [loading]="dashboardLoading()"
            tone="wallet"
            align="start"
            [clickable]="false"
          />
        </div>
      </article>
    </div>
  </section>
  }

  <ng-container *ngTemplateOutlet="attentionSection" />
  }
</div>

<ng-template #attentionSection>
  <section class="staff-dashboard__attention">
    <div class="staff-dashboard__attention-head">
      <span class="core-title">{{ 'STAFF.DASHBOARD.ATTENTION.TITLE' | translate }}</span>
      <button type="button" class="staff-dashboard__view-all" (click)="openOrders()">
        {{ 'admin.viewAll' | translate }}
      </button>
    </div>

    @if (orderStatsLoading()) {
    <p class="order-stats-hint">{{ 'admin.storageRequests.homeStatsLoading' | translate }}</p>
    } @else if (orderStatsAccessDenied()) {
    <p class="order-stats-hint order-stats-hint--error">
      {{ 'admin.storageRequests.accessDenied' | translate }}
    </p>
    } @else if (orderStatsError()) {
    <p class="order-stats-hint order-stats-hint--error">
      {{ 'admin.storageRequests.loadError' | translate }}
    </p>
    } @else {
    @if (orderStatsAttentionTotal() > 0) {
    <p class="order-overview__summary">
      {{ 'admin.storageRequests.homeStatsAttention' | translate: { count: orderStatsAttentionTotal() } }}
    </p>
    }

    <div class="order-overview">
      <div class="order-overview__head" aria-hidden="true">
        <span class="order-overview__head-type"></span>
        @for (status of orderHomeStatusStats; track status.id) {
        <span class="order-overview__head-status">{{ status.labelKey | translate }}</span>
        }
      </div>
      @for (kind of orderKindStats; track kind.id) {
      <div class="order-overview__row">
        <button type="button" class="order-overview__type" (click)="openOrdersByType(kind)">
          {{ kind.labelKey | translate }}
        </button>
        @for (status of orderHomeStatusStats; track status.id) {
        <button
          type="button"
          class="order-overview__count"
          [class.order-overview__count--active]="orderTypeStatusCount(kind, status) > 0"
          (click)="openOrdersByTypeAndStatus(kind, status)"
        >
          {{ orderTypeStatusCount(kind, status) }}
        </button>
        }
      </div>
      }
    </div>
    }
  </section>
</ng-template>
